export const RECORD_BTN_HOVER_TEXTS = [
  'Don’t forget to smile 😉',
  'Video, or it didn’t happen! 🤔',
  'Happy recording! 🎉',
  'Smile, beautiful! 😃',
];

export enum RequestStatus {
  INITIAL = 'initial',
  RECORDER = 'recorder',
  INVALID = 'invalid',
  FINAL = 'final',
  RECORDING = 'recording',
  PERMISSION = 'permission',
}
